import { InventoryItemJSON } from "../utils/game/mechanics/InventoryItemJSON";
import InventoryItem from "../utils/game/mechanics/InventoryItem";
import CreateTrackableAsyncFunction from "../utils/CreateTrackableAsyncFunction";

const getItemBankItemListURL =
    "https://ayaseye.com/api/item_bank/get_items.php";

async function getItemBankItemList(args: {
    token?: string;
}): Promise<Array<InventoryItem>> {
    const payload = { token: args.token };

    const response = await fetch(`${getItemBankItemListURL}`, {
        method: "POST",
        body: JSON.stringify(payload),
    }).then(async (res) => {
        const resultData = await res.json();
        if (Array.isArray(resultData)) {
            return resultData.map((entry) => InventoryItem.fromJSON(entry));
        }
        return [];
    });

    return response;
}

export function useGetItemBankItemList() {
    return CreateTrackableAsyncFunction(getItemBankItemList);
}
